(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-sidebar"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSidebar(toggle) {
      const wrapper = toggle.closest('[id^="shopify-block"]') || toggle.parentElement;
      const drawer = wrapper.querySelector('[data-sidebar-drawer]');
      const overlay = wrapper.querySelector('[data-sidebar-overlay]');
      const close = wrapper.querySelector('[data-sidebar-close]');
      const mainPanel = wrapper.querySelector('.sidebar-drawer__panel--main');
      let panelStack = [];

      // Teleport drawer and overlay to <body> so they escape any
      // backdrop-filter / stacking context created by the sticky header.
      if (drawer && drawer.parentElement !== document.body) {
        document.body.appendChild(overlay);
        document.body.appendChild(drawer);
      }

      /* ── Shopify customizer: open when this block is selected ── */
      var blockId = drawer ? drawer.getAttribute('data-block-id') : null;
      if (blockId) {
        document.addEventListener('shopify:block:select', function(e) {
          if (e.detail.blockId === blockId) {
            open();
          }
        });
        document.addEventListener('shopify:block:deselect', function(e) {
          if (e.detail.blockId === blockId) {
            closeDrawer();
          }
        });
      }

      function open() {
        drawer.classList.add('is-open');
        overlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('drawer-is-open');
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-visible');
        document.body.style.overflow = '';
        document.body.classList.remove('drawer-is-open');
        setTimeout(function() {
          mainPanel.classList.remove('is-hidden');
          drawer.querySelectorAll('.sidebar-drawer__panel--sub').forEach(function(p) {
            p.classList.remove('is-active');
          });
          drawer.classList.remove('has-image-panel');
          panelStack = [];
        }, 350);
      }

      toggle.addEventListener('click', open);
      close && close.addEventListener('click', closeDrawer);
      overlay && overlay.addEventListener('click', closeDrawer);

      // Panel navigation queries inside drawer directly (now lives on body)
      drawer.addEventListener('click', function(e) {
        const openBtn = e.target.closest('[data-open-panel]');
        if (openBtn) {
          const handle = openBtn.dataset.openPanel;
          const nextPanel = drawer.querySelector('[data-panel="' + handle + '"]');
          if (!nextPanel) return;
          const currentPanel = panelStack.length
            ? drawer.querySelector('[data-panel="' + panelStack[panelStack.length - 1] + '"]')
            : mainPanel;
          if (currentPanel) currentPanel.classList.add('is-hidden');
          nextPanel.classList.add('is-active');
          panelStack.push(handle);
          if (nextPanel.classList.contains('sidebar-drawer__panel--with-images')) {
            drawer.classList.add('has-image-panel');
          } else {
            drawer.classList.remove('has-image-panel');
          }
        }

        const backBtn = e.target.closest('[data-close-panel]');
        if (backBtn) {
          const currentHandle = panelStack.pop();
          const currentPanel = drawer.querySelector('[data-panel="' + currentHandle + '"]');
          if (currentPanel) currentPanel.classList.remove('is-active');
          if (panelStack.length > 0) {
            const prevPanel = drawer.querySelector('[data-panel="' + panelStack[panelStack.length - 1] + '"]');
            if (prevPanel) prevPanel.classList.remove('is-hidden');
            if (prevPanel && prevPanel.classList.contains('sidebar-drawer__panel--with-images')) {
              drawer.classList.add('has-image-panel');
            } else {
              drawer.classList.remove('has-image-panel');
            }
          } else {
            mainPanel.classList.remove('is-hidden');
            drawer.classList.remove('has-image-panel');
          }
        }
      });
    }

    document.querySelectorAll('[data-sidebar-toggle]').forEach(initSidebar);

    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('[data-sidebar-toggle]').forEach(initSidebar);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
